import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import eventBus         from 'EventBus.js';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/main/format.ejs';


class MainFormatView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change select' : 'updateSelectAttributes'
        };

        // Add needed property
        if (!this.model.get('customFormat')){
            this.model.set('customFormat', '', {silent: true});
        }

        if (!this.model.get('format')) {
            this.model.set('format', 'none', {silent: true});
        }

        this.listenTo( eventBus, 'validateTextValue', this.validateText);
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    updateTextValue(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
        this.validateText();
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set( propName, propVal );

        if (propName=== 'format'){
            this.validateText();
        }
    }

    validateText() {
        let option = this.model.get('format');
        let textvalue = this.model.get('text');

        switch (option) {
            case 'alpha':
                let reAlpha = /^[A-z]+$/;
                if ( !reAlpha.test(textvalue) ){
                    this.resetTextValue();
                }
                break;
            case 'numeric':
                if ( !$.isNumeric(textvalue) ) {
                    this.resetTextValue();
                }
                break;
            case 'alphanumeric':
                let reAlphaNum = /^[a-zA-Z0-9]*$/;
                if ( !reAlphaNum.test(textvalue) ) {
                    this.resetTextValue();
                }
                break;
            case 'email':
                let reEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if( !reEmail.test(textvalue) ) {
                    this.resetTextValue();
                }
                break;
            case 'url':
                let urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]*)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/;
                if ( !urlPattern.test(textvalue) ) {
                    this.resetTextValue();
                }
                break;
            case 'phone':
                //let rePhone = /^\+(?:[0-9]●?){6,14}[0-9]$/;
                let rePhone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                if ( !rePhone.test(textvalue) ) {
                    this.resetTextValue();
                }
                break;
            case 'custom':
                let customFormat = this.model.get('customFormat');
                if ( customFormat !== '' ) {
                    //TODO
                }
                break;
            case 'text':
            case 'none':
            default:
                break;
        }
    }

    resetTextValue(){
        this.model.set('text', '');
        this.render();
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //Set Dropdowns
        if (this.model.get('format')) {
            var ddValue = this.model.get('format');
            var ddl = $('#format');

            if($('#format').find('option[value="' + this.model.get('format') + '"]').length===0){
                this.model.set('format', 'none', {silent: true});
                ddValue = this.model.get('format');
            }

            ddl.val(ddValue);

            if (ddValue === "custom") {
                $('#customFormat').prop('disabled', false);
            }
            else {
                $('#customFormat').prop('disabled', true);
                $('#customFormat').val('');
                this.model.set('customFormat', '', {silent: true});
            }
            $('#format').find('option[value="' + this.model.get('format') + '"]').attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }

}

export default MainFormatView;
